import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ProductType } from "@obg/core.config";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { PlatformService } from "@obg/ngx.global";
import { filter, map, switchMap, take, tap } from "rxjs/operators";

import { APP_CONTEXT_ACTION_TYPE } from "../app-context/app-context.action";

import { PreloadConfigService } from "./preload.config";
import { PreloadService } from "./preload.service";

@Injectable()
export class PreloadEffect {
	saveLastVisitedLobby$ = this.platformService.forClient(() =>
		createEffect(
			() =>
				this.actions$.pipe(
					ofType(APP_CONTEXT_ACTION_TYPE.setProduct),
					filter(() => this.isEnabled()),
					map((action: ActionWithPayload<ProductType>) => action.payload),
					filter((product) => product !== ProductType.Common && product !== ProductType.ProviderPlugin),
					switchMap((product) => this.service.saveLastProduct(product))
				),
			{ dispatch: false }
		)
	);

	preload$ = this.platformService.forClient(() =>
		createEffect(
			() =>
				this.actions$.pipe(
					ofType(APP_CONTEXT_ACTION_TYPE.setProduct),
					filter(() => this.isEnabled()),
					map((action: ActionWithPayload<ProductType>) => action.payload),
					filter((product) => product === ProductType.Common || product === ProductType.ProviderPlugin),
					take(1),
					tap((product: ProductType.Common | ProductType.ProviderPlugin) => this.service.preload(product))
				),
			{ dispatch: false }
		)
	);

	constructor(
		private actions$: Actions,
		private config: PreloadConfigService,
		private service: PreloadService,
		private platformService: PlatformService
	) {}

	private isEnabled(): boolean {
		return this.config.getEnabled();
	}
}
